import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useOrgContext } from '@/providers/org-provider';

/**
 * Lands the user on their default org's dashboard after sign-in. Reads
 * the persisted lastOrgId from localStorage when set; otherwise falls
 * back to the first org in the list (typically the user's personal
 * workspace, since signup auto-creates one).
 */
export function PostLoginRedirect() {
  const { orgs, isLoading } = useOrgContext();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading) return;
    if (orgs.length === 0) {
      // Should not normally happen — auth middleware lazy-creates the
      // personal org. If it does, send to org-create as a safety net.
      navigate('/orgs/new', { replace: true });
      return;
    }
    const lastId = (() => {
      try { return localStorage.getItem('lastOrgId'); } catch { return null; }
    })();
    const target = orgs.find((o) => o.orgId === lastId) ?? orgs[0];
    navigate(`/orgs/${target.orgId}/dashboard`, { replace: true });
  }, [orgs, isLoading, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center text-muted-foreground">
      <Loader2 className="h-5 w-5 animate-spin" />
    </div>
  );
}
